import React, { Fragment } from "react";
import { FormInput } from "root/ReactHookForm/FormComponents/FormInput";
import { EMAIL_ALL_FIELDS } from "root/Modals/ModalEmailAll";

const FormFragmentSignature = ({data, watch, control, register, formErrors, sectionName, readOnly}) =>
{

    return (
        <Fragment>
            <div>
                <div>
                    <label className='form-label'>Signature (Optional)</label>
                    <FormInput control={control} register={register} sectionName={sectionName} formErrors={formErrors} name={EMAIL_ALL_FIELDS.SIGN}/>
                </div>
            </div>
        </Fragment>
    );
}

export default FormFragmentSignature;